import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * ONE empty state. RC-15 / RC-17, and Pattern C.
 *
 * THE DEFECT. Four surfaces rendered "there is nothing here" four ways: the
 * Director dashboard had a local `EmptyHint` with an icon tile, a title, a hint
 * and a call to action; the Assistant Manager dashboard had the same markup
 * inlined and copied; the Sales Officer dashboard had a third copy; and the
 * analytics leaderboards had a bare centred `<p>` with no icon, no hint and no
 * way out — a leaderboard with no empty state at all, which is the RC-15 entry.
 *
 * The shape promoted here is the Director/Assistant Manager one, because it is
 * the only one that answers the second question. "No approved leaves yet this
 * year" tells the reader the list is empty; it does not tell them whether that
 * is expected, nor where to go. `hint` and `cta` are what make an empty state
 * different from a blank.
 *
 * AN EMPTY STATE IS NOT A ZERO (Pattern A). This renders when a collection is
 * KNOWN to be empty. A collection that failed to load is a different fact and
 * must say so in its own words — see `lib/vocabulary.js`.
 */
export default function EmptyHint({ Icon, title, hint, cta, testId }) {
  return (
    <div
      className="flex flex-col items-center text-center px-3 py-8"
      data-testid={testId || undefined}
    >
      {Icon && (
        <div className="h-12 w-12 rounded-lg bg-callisto-navy/5 flex items-center justify-center mb-3">
          <Icon className="h-5 w-5 text-callisto-navy" strokeWidth={1.75} />
        </div>
      )}
      <p className="text-sm font-semibold text-callisto-navy">{title}</p>
      {hint && <p className="mt-1 text-xs text-callisto-muted max-w-sm">{hint}</p>}
      {cta && (
        <Link
          to={cta.to}
          className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-callisto-gold hover:underline"
        >
          {cta.label} <ArrowUpRight size={12} />
        </Link>
      )}
    </div>
  );
}
